import { Box, Stack, styled } from '@mui/material';

export const SkeletonContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'flex-start',
	padding: 12,
	borderRadius: 8,
	backgroundColor: theme.palette.neutral.main,
	border: '0.5px solid #66758F',
	cursor: 'not-allowed',
}));

export const LabelWrapper = styled(Box)(() => ({
	display: 'flex',
	flexWrap: 'wrap',
	rowGap: '8px',
	marginTop: 8,
}));

export const LoadingContentWrapper = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	gap: 8,
	alignItems: 'flex-start',
}));

export const SkeletonIconWrapper = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	width: 'fit-content',
	overflow: 'hidden',
}));

export const ChevronWrapper = styled(Stack)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	color: theme.palette.primary.main,
	'& svg': {
		width: 16,
		height: 16,
	},
}));
